import { render, staticRenderFns } from "./allHead.vue?vue&type=template&id=6b4f4de3&scoped=true"
import script from "./allHead.vue?vue&type=script&lang=js"
export * from "./allHead.vue?vue&type=script&lang=js"
import style0 from "./allHead.vue?vue&type=style&index=0&id=6b4f4de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f4de3",
  null
  
)

export default component.exports